module.exports = __webpack_public_path__ + "img/symbol_3.cb29b86d.png";